import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { Note, ApiResponse, PaginatedResponse } from '@/types/table';

export const noteService = {
  getAll: async (): Promise<PaginatedResponse<Note>> => {
    const response = await api.get(API_ROUTES.NOTES);
    return response.data;
  },

  create: async (data: Partial<Note>): Promise<ApiResponse<Note>> => {
    const response = await api.post(API_ROUTES.NOTES, data);
    return response.data;
  },

  update: async (id: string, data: Partial<Note>): Promise<ApiResponse<Note>> => {
    const response = await api.patch(`${API_ROUTES.NOTES}/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`${API_ROUTES.NOTES}/${id}`);
  },

  togglePin: async (id: string): Promise<ApiResponse<Note>> => {
    const response = await api.patch(`${API_ROUTES.NOTES}/${id}/pin`);
    return response.data;
  },
};
